import './DetailsMoile.scss';

import DetailsMobileHeader from "../DetailsMobileHeader/DetailsMobileHeader";
import DetailsMobileContent from "../DetailsMobileContent/DetailsMobileContent";

const DetailsMobile = () => {

    return (
        <div className={"details-mobile"}>
            <div className={"details-mobile_container"}>
                <div className={"details-mobile_header"}>
                    <DetailsMobileHeader/>
                </div>
                <div className={"details-mobile_content"}>
                    <DetailsMobileContent/>
                </div>
            </div>
        </div>
    )
}

export default DetailsMobile;